
const qaoa = () => {
    return (
        <a className="project-link" href="https://qaoa-maxcut.onrender.com/" target="_blank" rel="noopener noreferrer">
        <div className="qaoa">
            <div className="project-header">
                <img src="./images/qubitBR.png" alt="QAOA for MaxCut" className="project-image" />
                <h2>QAOA for MaxCut</h2>
            </div>
        </div>
        </a>
    );
};

export default qaoa;
